import React from "react";
import {
    useSiteRentalPaymentMethodsQueryQuery
} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SiteRentalPaymentMethodSelect = (props) => {
    const query = useSiteRentalPaymentMethodsQueryQuery();
    return <GraphQlSelect {...props} queryResult={query} labelField="label"/>;
}

